import { DROPDOWN_TYPES } from "../actions/importAction";

const { JSON_UPDATE_SUCCESS, VALIDATION_UPDATE_SUCCESS,RESET_VALIDATION } = DROPDOWN_TYPES;

const initialState = {
  jsonStructure: {
    images: [],
    fonts: [],
    videos: [],
    docs: [],
    plugins: {
      css: [],
      js: [],
    },
    shared: {
      css: "",
      js: "",
    },
    css: "",
    html: "",
    js: "",
    thumbImage: "",
    fullImage: "",
    name: "",
  },
  validationData:{
  'Images':"",
  'Videos':"",
  'Fonts':"",
  'Docs':"",
  'CSS':"",
  'JS':"",
  'SharedFolder-CSS':"",
  'SharedFolder-JS':"",},
};

const importJSONReducer = (state = initialState, action) => {
  switch (action.type) {
    case JSON_UPDATE_SUCCESS:
      const { keyValue, dataToUpdate, isPlugins, isShared} = action.data;
      const updatedJSON = { ...state.jsonStructure };

      if (isShared) {
        updatedJSON.shared = {
          ...state.jsonStructure.shared,
          [keyValue]: dataToUpdate,
        };
      } else if (isPlugins) {
        updatedJSON.plugins = {
          ...state.jsonStructure.plugins,
          [keyValue]: dataToUpdate,
        };
      }else {
        updatedJSON[keyValue] = dataToUpdate;
      }

      return {
        ...state,
        jsonStructure: updatedJSON,
      };

    case VALIDATION_UPDATE_SUCCESS:
      const {title,item}=action.data;
      const updatedvalidationData={...state.validationData}
      updatedvalidationData[title] = item;
      return{
        ...state,
        validationData:updatedvalidationData
      }
    
    case RESET_VALIDATION: 
      return {
        ...state,
        validationData: initialState.validationData
      }

    default:
      return state;
  }
};

export default importJSONReducer;
